module.exports = __webpack_public_path__ + "static/img/want_want.e396bca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/logo/want_want.png
// module id = CpNV
// module chunks = 1